module.exports = __webpack_public_path__ + "static/media/mapbox.f6d416d4.PNG";